import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

interface MetricBarChartSkeletonProps {
    height?: string;
    barCount?: number;
    labelWidth?: number;
    showMetadataIcon?: boolean;
    showSubText?: boolean;
    showValue?: boolean;
}

const MetricBarChartSkeleton = ({
    height = "h-40",
    barCount = 5,
    labelWidth = 100,
    showMetadataIcon = true,
    showSubText = true,
    showValue = false,
}: MetricBarChartSkeletonProps) => {
    const getBarWidth = (index: number) => {
        const widths = [92, 82, 72, 64, 54, 46, 38, 32];
        return `${widths[index % widths.length]}%`;
    };

    return (
        <div className="relative overflow-hidden rounded-xl border bg-white">
            <div className="p-3 bg-white">
                <div className="flex items-center justify-between gap-3">
                    <div className="min-w-0 flex-1">
                        <Skeleton height={15} width={170} />

                        {(showSubText || showValue) && (
                            <div className="mt-1 flex items-center gap-2">
                                {showSubText && (
                                    <Skeleton height={11} width={150} />
                                )}

                                {showValue && (
                                    <Skeleton height={11} width={42} />
                                )}
                            </div>
                        )}
                    </div>

                    {showMetadataIcon && (
                        <Skeleton
                            height={24}
                            width={24}
                            borderRadius={6}
                        />
                    )}
                </div>
            </div>

            <div className={`${height} bg-white px-3 pb-3 min-h-[120px]`}>
                <div className="flex h-full flex-col justify-center gap-3">
                    {Array.from({ length: barCount }).map((_, index) => (
                        <div
                            key={`metric-bar-chart-skeleton-row-${index}`}
                            className="flex items-center gap-3"
                        >
                            <div
                                style={{
                                    width: labelWidth,
                                }}
                            >
                                <Skeleton height={10} width="90%" />
                            </div>

                            <div className="flex-1">
                                <Skeleton
                                    height={14}
                                    width={getBarWidth(index)}
                                    borderRadius={4}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-[#2258e5]/50 to-[#00ac4e]/50 opacity-0 transition-opacity group-hover:opacity-100" />
        </div>
    );
};

export default MetricBarChartSkeleton;